module.exports = __webpack_public_path__ + "./Kate_color_3da64b5852c17c1044881104853d3abf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Kate_color.jpg
// module id = 592
// module chunks = 0